<template>
  <a-row :gutter="24">
    <a-col :md="24">
      <a-card :style="cardStyle" :bordered="false">
        <!-- 顶部门店选择（店内设置按门店分组存储） -->
        <div class="table-page-search-wrapper">
          <a-form layout="inline">
            <a-row :gutter="24">
              <a-col :md="8" :sm="24">
                <a-form-item label="所属门店" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-select v-model="storeId" placeholder="请选择门店" @change="onStoreChange">
                    <a-select-option v-for="s in storeOptionList" :key="s.id" :value="s.id">{{ s.name }}</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
            </a-row>
          </a-form>
        </div>
        <a-tabs v-model="activeTab">
          <!-- ============ 堂食设置（克隆云贝截图1） ============ -->
          <a-tab-pane tab="堂食设置" key="instore">
            <a-form class="setting-form">
              <a-form-item label="营业时间" :labelCol="formLabelCol" :wrapperCol="formWrapperCol" required>
                <a-radio-group v-model="form.timeType">
                  <a-radio value="1">全天24小时营业</a-radio>
                  <a-radio value="2">设置营业时间</a-radio>
                </a-radio-group>
                <div v-if="form.timeType === '2'" class="time-rows">
                  <div v-for="(item, index) in timeArr" :key="index" class="time-row">
                    <a-time-picker
                      :value="toMoment(item.startTime)"
                      format="HH:mm"
                      :minute-step="5"
                      :allow-clear="false"
                      placeholder="选择时间"
                      style="width: 150px"
                      @change="(t, val) => onTimeChange(item, 'startTime', val)" />
                    <span class="time-sep">-</span>
                    <span v-if="item.ciri" class="time-ciri">次日</span>
                    <a-time-picker
                      :value="toMoment(item.endTime)"
                      format="HH:mm"
                      :minute-step="5"
                      :allow-clear="false"
                      placeholder="选择时间"
                      style="width: 150px"
                      @change="(t, val) => onTimeChange(item, 'endTime', val)" />
                    <a class="time-del" @click="delTimeInterval(index)">删除</a>
                  </div>
                  <a-button v-show="timeArr.length < 3" type="link" icon="plus" @click="addTimeInterval">添加营业时间</a-button>
                </div>
              </a-form-item>
              <a-form-item label="商家公告" :labelCol="formLabelCol" :wrapperCol="formWrapperCol">
                <a-textarea v-model="form.notice" placeholder="请输入商家公告" :rows="3" />
              </a-form-item>
              <a-form-item label="下单公告" :labelCol="formLabelCol" :wrapperCol="formWrapperCol">
                <a-textarea v-model="form.orderNotice" placeholder="请输入下单公告" :rows="3" />
              </a-form-item>
              <a-form-item label="下单幻灯片" :labelCol="formLabelCol" :wrapperCol="formWrapperCol">
                <j-image-upload v-model="form.orderMedia" bizPath="material" text="上传幻灯片" isMultiple />
              </a-form-item>
              <a-form-item label="自动接单" :labelCol="formLabelCol" :wrapperCol="formWrapperCol">
                <a-radio-group v-model="form.receiving">
                  <a-radio value="1">开启</a-radio>
                  <a-radio value="2">关闭</a-radio>
                </a-radio-group>
                <div class="field-tip">商家接单后才打印小票,为防漏单建议开启</div>
              </a-form-item>
              <a-form-item label="结算模式" :labelCol="formLabelCol" :wrapperCol="formWrapperCol">
                <a-radio-group v-model="form.payMode">
                  <a-radio value="1">先结账后用餐</a-radio>
                  <a-radio value="2">先用餐后结账</a-radio>
                </a-radio-group>
                <div v-show="form.payMode === '1'" class="field-tip">顾客点餐付钱后,商家即可收到订单准备上菜</div>
                <div v-show="form.payMode === '2'" class="field-tip">顾客点餐下单给商家,商家开始准备上菜,顾客可以吃完后付钱,未支付顾客可以加菜</div>
              </a-form-item>
              <!-- 联动：仅 payMode=2 显示线上支付 -->
              <a-form-item v-show="form.payMode === '2'" label="线上支付" :labelCol="formLabelCol" :wrapperCol="formWrapperCol">
                <a-radio-group v-model="form.onLine">
                  <a-radio value="1">开启</a-radio>
                  <a-radio value="2">关闭</a-radio>
                </a-radio-group>
                <div class="field-tip">关闭后用户端将不显示支付按钮，仅能线下结账</div>
              </a-form-item>
              <!-- 联动：仅 payMode=1 显示清台设置+清台时间 -->
              <a-form-item v-show="form.payMode === '1'" label="清台设置" :labelCol="formLabelCol" :wrapperCol="formWrapperCol">
                <a-radio-group v-model="form.autoClose">
                  <a-radio value="1">开启</a-radio>
                  <a-radio value="2">关闭</a-radio>
                </a-radio-group>
                <div class="field-tip">开启后，未支付订单将在设置的清台时间后自动关单并释放桌台，此功能仅在先结账后用餐模式下生效</div>
              </a-form-item>
              <a-form-item v-show="form.payMode === '1' && form.autoClose === '1'" label="清台时间" :labelCol="formLabelCol" :wrapperCol="formWrapperCol">
                <a-input-number v-model="form.closeTime" :min="1" :precision="0" placeholder="请输入清台时间" style="width: 200px" />
                <span class="unit-text">分钟后自动清台</span>
              </a-form-item>
              <a-form-item label="点餐模式" :labelCol="formLabelCol" :wrapperCol="formWrapperCol">
                <a-radio-group v-model="form.orderMode">
                  <a-radio value="1">多人点餐</a-radio>
                  <a-radio value="2">拼桌点餐</a-radio>
                </a-radio-group>
                <div v-show="form.orderMode === '1'" class="field-tip">同桌共享购物车，互相可见</div>
                <div v-show="form.orderMode === '2'" class="field-tip">多人共用一桌，各自独立点餐下单</div>
              </a-form-item>
              <a-form-item label="服务费" :labelCol="formLabelCol" :wrapperCol="formWrapperCol">
                <a-radio-group v-model="form.serviceType">
                  <a-radio value="1">按就餐人数收取</a-radio>
                  <a-radio value="2">按每桌台收取</a-radio>
                </a-radio-group>
                <div class="service-fee">
                  <a-input-number v-model="form.serviceMoney" :min="0" :precision="2" placeholder="请输入服务费金额" style="width: 200px" />
                  <!-- 联动：serviceType=1 单位"元/位"，=2 单位"元/桌" -->
                  <span class="unit-text">元/{{ form.serviceType === '1' ? '位' : '桌' }}</span>
                </div>
              </a-form-item>
              <a-form-item label="选择人数开关" :labelCol="formLabelCol" :wrapperCol="formWrapperCol">
                <a-radio-group v-model="form.select_numbe_switch">
                  <a-radio value="1">开启</a-radio>
                  <a-radio value="2">关闭</a-radio>
                </a-radio-group>
                <div class="field-tip">开启后,桌码扫码提示选择就餐人数</div>
              </a-form-item>
            </a-form>
            <div class="form-footer">
              <a-button type="primary" :loading="saving" @click="handleSave('instore')">保存</a-button>
            </div>
          </a-tab-pane>
          <!-- ============ 快餐设置（克隆云贝截图2） ============ -->
          <a-tab-pane tab="快餐设置" key="fast">
            <a-form class="setting-form">
              <a-form-item label="自动接单" :labelCol="formLabelCol" :wrapperCol="formWrapperCol">
                <a-radio-group v-model="form2.receiving">
                  <a-radio value="1">开启</a-radio>
                  <a-radio value="2">关闭</a-radio>
                </a-radio-group>
                <div class="field-tip">此功能关闭后,商家需要手动接单</div>
              </a-form-item>
              <a-form-item label="快餐公告" :labelCol="formLabelCol" :wrapperCol="formWrapperCol">
                <a-textarea v-model="form2.notice" placeholder="请输入快餐公告" :rows="3" />
              </a-form-item>
              <a-form-item label="下单公告" :labelCol="formLabelCol" :wrapperCol="formWrapperCol">
                <a-textarea v-model="form2.orderNotice" placeholder="请输入下单公告" :rows="3" />
              </a-form-item>
              <a-form-item label="下单幻灯片" :labelCol="formLabelCol" :wrapperCol="formWrapperCol">
                <j-image-upload v-model="form2.orderMedia" bizPath="material" text="上传幻灯片" isMultiple />
              </a-form-item>
              <a-form-item label="打包盒收费模式" :labelCol="formLabelCol" :wrapperCol="formWrapperCol">
                <a-radio-group v-model="form2.boxType">
                  <a-radio value="1">按订单收费</a-radio>
                  <a-radio value="2">按商品收费</a-radio>
                </a-radio-group>
                <div class="field-tip">假设打包盒2元,按订单收费是指该订单收取2元打包费</div>
              </a-form-item>
              <!-- 联动：boxType=1 显示打包盒费 -->
              <a-form-item v-show="form2.boxType === '1'" label="打包盒费" :labelCol="formLabelCol" :wrapperCol="formWrapperCol">
                <a-input-number v-model="form2.boxMoney" :min="0" :max="100000000" :precision="2" placeholder="请输入打包盒费" style="width: 200px" />
                <span class="unit-text">元</span>
              </a-form-item>
              <a-form-item label="取餐语音文字" :labelCol="formLabelCol" :wrapperCol="formWrapperCol">
                <!-- 克隆云贝三段式：前段(placeholder"请") + 固定"A001" + 后段(placeholder"号到服务台取餐") -->
                <a-input v-model="form2.phoneticWritingStart" placeholder="请" addonAfter="A001" style="width: 260px" />
                <a-input v-model="form2.phoneticWritingEnd" placeholder="号到服务台取餐" style="width: 240px; margin-left: 10px" />
              </a-form-item>
            </a-form>
            <div class="form-footer">
              <a-button type="primary" :loading="saving" @click="handleSave('fast')">保存</a-button>
            </div>
          </a-tab-pane>
        </a-tabs>
      </a-card>
    </a-col>
  </a-row>
</template>

<script>
import moment from 'moment'
import { getAction, putAction } from '@/api/manage'
import { storeOptions } from '@/api/plugin/dining'
import { mixinDevice } from '@/utils/mixin'
import JImageUpload from '@/components/jeecg/JImageUpload'

/**
 * 店内设置（堂食/快餐两 Tab，完全克隆云贝 chunk-e6f72918 店内设置页）
 * API 契约：GET/PUT /api/plugin/dining/store-setting/{type}，type ∈ instore/fast
 * 无记录时后端返回默认值，保存时整组覆盖
 */
const SETTING_PREFIX = '/api/plugin/dining/store-setting'

// 堂食默认值（spec 1.2）
const INSTORE_DEFAULTS = {
  timeType: '1',
  notice: '',
  orderNotice: '',
  orderMedia: '',
  receiving: '2',
  payMode: '1',
  onLine: '1',
  autoClose: '2',
  closeTime: 3,
  orderMode: '1',
  serviceType: '1',
  serviceMoney: 0,
  select_numbe_switch: '2'
}

// 快餐默认值（spec 1.3）
const FAST_DEFAULTS = {
  receiving: '2',
  notice: '',
  orderNotice: '',
  orderMedia: '',
  boxType: '2',
  boxMoney: 0,
  phoneticWritingStart: '',
  phoneticWritingEnd: ''
}

export default {
  name: 'DiningStoreSetting',
  mixins: [mixinDevice],
  components: { JImageUpload },
  data() {
    return {
      labelCol: { span: 5 },
      wrapperCol: { span: 18, offset: 1 },
      formLabelCol: { span: 5 },
      formWrapperCol: { span: 18, offset: 1 },
      activeTab: 'instore',
      storeOptionList: [],
      storeId: null,
      form: Object.assign({}, INSTORE_DEFAULTS),
      form2: Object.assign({}, FAST_DEFAULTS),
      timeArr: [],
      saving: false,
      cardStyle: ''
    }
  },
  created() {
    // 卡片高度自适应（照 JeecgListMixin 处理，设置页无表格不引混入）
    if (this.isDesktop()) {
      this.cardStyle = 'height:' + (document.documentElement.clientHeight - 100) + 'px'
    }
    this.loadStores()
  },
  methods: {
    loadStores() {
      storeOptions().then(res => {
        if (res.code === 200) {
          this.storeOptionList = res.data || []
          if (this.storeOptionList.length) {
            this.storeId = this.storeOptionList[0].id
            this.loadAll()
          }
        } else {
          this.$message.warning(res.message)
        }
      })
    },
    onStoreChange() {
      this.loadAll()
    },
    // 切店后一次性加载堂食+快餐两组设置（切 Tab 不重复请求）
    loadAll() {
      if (!this.storeId) {
        return
      }
      getAction(SETTING_PREFIX + '/instore', { storeId: this.storeId }).then(res => {
        if (res.code === 200) {
          this.form = Object.assign({}, INSTORE_DEFAULTS, res.data || {})
          this.timeArr = this.parseTimeArr(res.data)
        } else {
          this.$message.warning(res.message)
        }
      })
      getAction(SETTING_PREFIX + '/fast', { storeId: this.storeId }).then(res => {
        if (res.code === 200) {
          this.form2 = Object.assign({}, FAST_DEFAULTS, res.data || {})
        } else {
          this.$message.warning(res.message)
        }
      })
    },
    parseTimeArr(data) {
      if (data && Array.isArray(data.timeArr) && data.timeArr.length) {
        return data.timeArr.map(item => ({
          startTime: item.startTime || '00:00',
          endTime: item.endTime || '00:00',
          ciri: !!item.ciri
        }))
      }
      return []
    },
    toMoment(val) {
      return val ? moment(val, 'HH:mm') : null
    },
    // ===== 营业时间时段组（克隆云贝 addtimeInterval/deltimeInterval/selectTime：最多3组，起止跨天自动标"次日"）=====
    addTimeInterval() {
      if (this.timeArr.length >= 3) {
        return
      }
      this.timeArr.push({ startTime: '00:00', endTime: '00:00', ciri: true })
    },
    delTimeInterval(index) {
      this.timeArr.splice(index, 1)
    },
    onTimeChange(item, field, val) {
      item[field] = val || '00:00'
      if (field === 'startTime') {
        item.ciri = item.startTime >= item.endTime
      } else {
        item.ciri = item.endTime <= item.startTime
      }
    },
    // ===== 保存（整组提交，成功提示"保存成功"）=====
    handleSave(type) {
      if (!this.storeId) {
        return
      }
      let body
      if (type === 'instore') {
        if (this.form.timeType === '2' && !this.timeArr.length) {
          this.$message.warning('营业时间为自定义时请添加营业时间时段')
          return
        }
        body = Object.assign({}, this.form, {
          timeArr: this.timeArr.map(item => ({ startTime: item.startTime, endTime: item.endTime, ciri: !!item.ciri }))
        })
      } else {
        body = Object.assign({}, this.form2)
      }
      this.saving = true
      putAction(SETTING_PREFIX + '/' + type + '?storeId=' + this.storeId, body).then(res => {
        if (res.code === 200) {
          this.$message.success('保存成功')
        } else {
          this.$message.warning(res.message)
        }
      }).finally(() => {
        this.saving = false
      })
    }
  }
}
</script>

<style scoped>
@import '~@assets/less/common.less';
.setting-form {
  max-width: 760px;
}
.field-tip {
  color: #999;
  font-size: 12px;
  line-height: 16px;
  margin-top: 4px;
}
.time-rows {
  margin-top: 10px;
}
.time-row {
  margin-bottom: 10px;
}
.time-sep {
  margin: 0 10px;
}
.time-ciri {
  margin-right: 10px;
  color: #ff6b35;
}
.time-del {
  margin-left: 10px;
  font-size: 12px;
}
.service-fee {
  margin-top: 10px;
}
.unit-text {
  margin-left: 10px;
  color: #666;
}
.form-footer {
  text-align: center;
  margin-top: 16px;
  border-top: 1px solid #e8e8e8;
  padding-top: 16px;
  max-width: 760px;
}
</style>
